// hotkeys/HotkeysSuppressor.tsx
import React, { useEffect } from "react";
import { useHotkeys } from "./HotkeysProvider";

/**
 * Component that suppresses hotkeys while mounted.
 * Useful for dialogs, modals, editors, or any component where
 * keyboard shortcuts should be disabled.
 */
export const HotkeysSuppressor: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { suppress } = useHotkeys();
  
  useEffect(() => {
    const unsuppress = suppress();
    return unsuppress;
  }, [suppress]);
  
  return <>{children}</>;
};

/**
 * Higher-order component version for wrapping existing components
 */
export const withHotkeysSuppressed = <P extends object>(
  WrappedComponent: React.ComponentType<P>
) => {
  const WithHotkeysSuppressed = (props: P) => (
    <HotkeysSuppressor>
      <WrappedComponent {...props} />
    </HotkeysSuppressor>
  );
  
  WithHotkeysSuppressed.displayName = `withHotkeysSuppressed(${WrappedComponent.displayName || WrappedComponent.name})`;
  
  return WithHotkeysSuppressed;
};